import { splitProps } from "solid-js";
import type { JSX } from "solid-js";

interface Props extends JSX.HTMLAttributes<HTMLDivElement> {
    name?: string;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
}

function initials(name?: string): string {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
    return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function Avatar(props: Props) {
    const [own, rest] = splitProps(props, ["name", "size", "class"]);
    const cls = () => ["ui-avatar", `ui-avatar-${own.size ?? "md"}`, own.class ?? ""].filter(Boolean).join(" ");
    return (
        <div
            {...rest}
            class={cls()}
            role="img"
            aria-label={own.name ? `Avatar de ${own.name}` : "Avatar"}
        >
            {initials(own.name)}
        </div>
    );
}
